import React, { Component, type ComponentType } from "react"

import { getReadableEntityName } from "../../config/util-functions"
import { images } from "../../config/image-definitions"
import DefaultShadowListItem from "./DefaultShadowListItem"
import infiniteScroller from "./InfiniteScroller"
import { range } from "../../config/util-functions"

const { searchIconLarge } = images

type Props = {
    containerClassName: string,
    data: Array<Object>,
    itemComponent: ComponentType<*>,
    shadowComponent: ComponentType<*>,
    itemStateProps: Object,
    itemActionProps: Object,
    isFetching: boolean,
    shouldDisplayShadow: boolean,
    onScroll: void => void,
    presentationAccessor: string,
    pagingRequest: Object,
    shouldShowEmptyMessage?: boolean,
    type?: string
}

class InfiniteScroll extends Component<Props> {
    render() {
        const {
            containerClassName,
            data,
            pagingRequest,
            itemStateProps,
            itemActionProps,
            itemComponent: ItemComponent,
            shadowComponent,
            isFetching,
            onScroll,
            presentationAccessor,
            shouldShowEmptyMessage
        } = this.props
        let { shouldDisplayShadow } = this.props
        const ShadowLoadingComponent = shadowComponent || DefaultShadowListItem

        const { isInvalidating, limit } = pagingRequest
        return (
            <div onScroll={onScroll} className={containerClassName}>
                {!isInvalidating &&
                    data.map((item, index) => (
                        <ItemComponent
                            {...item}
                            {...itemStateProps}
                            {...itemActionProps}
                            key={item.id || index}
                        />
                    ))}
                {(shouldDisplayShadow !== undefined
                    ? shouldDisplayShadow
                    : isFetching) &&
                    range(limit || 10).map(index => (
                        <ShadowLoadingComponent key={index} />
                    ))}
                {data.length === 0 &&
                !isFetching &&
                (shouldShowEmptyMessage === undefined
                    ? true
                    : shouldShowEmptyMessage) && (
                    <div className="inf-scroll-no-results-block">
                        <img
                            className="inf-scroll-search-img"
                            src={searchIconLarge}
                            alt="search icon"
                        />
                        <strong>
                            {"Your search didn't match any "}
                            {getReadableEntityName(presentationAccessor, true)}.
                        </strong>
                        <p>Please try a new query or different keywords.</p>
                    </div>
                )}
            </div>
        )
    }
}

export default infiniteScroller(InfiniteScroll)
